import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { RoutingService } from './routing.service';
import { lastValueFrom } from "rxjs";

@Injectable({ providedIn: 'root' })
export class eSafeService {
  private eSafe_URL = environment.eSafeAssetService.url + environment.eSafeAssetService.apiVersion;
  constructor(private http: HttpClient, private routeService: RoutingService) { }
 
  GetDocumentsCountForApproval(portalId: string) {
    return new Promise<any>((resolve, reject) => {
      lastValueFrom(this.http.get(this.eSafe_URL + "Document/Studies/" + portalId, {}))
        .then(
          (response?: any) => {
            resolve(response);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }
  GetStartupBinderByCoreStudy(coreStudyId: string) {
    return new Promise<any>((resolve, reject) => {
      lastValueFrom(this.http.get(this.eSafe_URL + "Binder/CoreStudy/" + coreStudyId + "/StartupBinders", {}))
        .then(
          (response?: any) => {
            resolve(response);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }
}
